<div class="po-card-accordion">
  <p-accordion [multiple]="true">
    <p-accordionTab [selected]="index == '0'">
      <!-- Campaign header -->
      <p-header>
        <h2 class="mb-0 font-14">
          <!-- <i class="fal fa-times-circle text-red inner-accordian-icon height-30 mt-15px flex-center-center pb-1"></i> -->
          <span class="inner-accordian-text mt-10px hover-underline pointer" (click)="openPO(data)">{{data.code}}</span>

          <div class="inner-accordian-delete mr-2 flex-self-start">
            <span>
              {{data?.totalAmount | currency: 'USD'}}
            </span>
          </div>
        </h2>
      </p-header>

      <!-- Campaign body -->
      <div class="inner-accordian-content">
        <!-- Follow-up date -->

        <div class="accordian-inner-row" style="display: flow-root;">
          <div  class="accordian-inner-col ticket-age">
            <i class="fal fa-calendar-alt inner-col-icon width-25px"></i>
            <div tooltipStyleClass="ticket-tooltip modifier ticket-size completed marketing-tooltip width-extend">
              <span class="inner-data text-truncate"> 
                {{data?.payableStatus || '-'}} </span>
            </div>
          </div>
        </div>
        <!-- Customer email -->
        <div class="accordian-inner-row" style="display: flow-root;" *ngIf="data.invoiceDate">
          <div  class="accordian-inner-col ticket-age">
            <i class="fas fa-truck inner-col-icon width-25px mt-2p"></i>
            <div tooltipStyleClass="ticket-tooltip modifier ticket-size completed marketing-tooltip width-extend">
              <span class="inner-data text-truncate"> Invoiced on  {{data?.invoiceDate}}</span>
            </div>
          </div>
        </div>

        <!-- Template text -->
        <div class="accordian-inner-row" style="display: flow-root;">
          <div class="accordian-inner-col full-width-columns align-items-start">
            <i class="fal fa-usd-circle inner-col-icon mt-1 width-25px"></i>
            <div class="inner-data two-line-elipsis">
              {{data?.paymentStatus}}
            </div>
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

</div>